import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "fengliu_favorites";

const readFavorites = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export function useFavorite(id: string) {
  const [fav, setFav] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setFav(readFavorites().includes(id));
    setReady(true);
  }, [id]);

  const toggle = useCallback(() => {
    setFav((prev) => {
      const next = !prev;
      const current = readFavorites();
      const updated = next
        ? Array.from(new Set([...current, id]))
        : current.filter((x) => x !== id);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      } catch {
        // storage unavailable — ignore
      }
      return next;
    });
  }, [id]);

  return { fav, toggle, ready };
}